<template>
  <div>
    <ViewTemplateReportList :panel="panel" :reports="reports" />
  </div>
</template>

<script>
import ViewTemplateReportList from "@nixweb/nixloc-ui/src/component/template/ViewTemplateReportList";

export default {
  name: "ReportRentalView",
  components: { ViewTemplateReportList },
  data() {
    return {
      panel: {
        module: "Operacional",
        title: "Relatório",
        showFilter: false,
        showSearch: true,
        showButtons: false,
      },
      reports: {
        default: [
          {
            name: "Saídas e Retornos",
            routeName: "reportDeliveryDevolution",
          },
        ],
        saved: [],
      },
    };
  },
};
</script>
